<template>
<el-drawer title="查看" size="100%" :visible.sync="drawerVisible" :append-to-body="true" :center="true" :wrapperClosable="false" :withHeader="false">
    <div style="padding:10px 0;">
        <!-- <order-detail :order="order" :wedding="wedding"></order-detail> -->
    </div>
    <div class="box-project">
        <div class="main-demand box-center">
            <div class="form-demand">
                <el-form ref="form" :model="ruleForm" label-width="80px">
                    <div class="form-header">
                        <div class="box-nav-more">
                            <el-button type="primary" @click="closeDrawer">关闭</el-button>
                        </div>
                        <div class="form-submit">
                            <el-button type="primary" @click="submit">提交</el-button>
                        </div>
                    </div>
                    <div class="selected-list">
                        <template v-for="tItem in tree">
                            <div class="selected-item" :key="tItem.id">
                                <div class="tree-title">
                                    <div class="mr8">{{tItem.title}}</div>
                                    <div class="mr8" v-if="type=='edit'">
                                        <el-select v-model="status_id" placeholder="派发状态" clearable class="mr8">
                                            <el-option v-for="item in statusList" :key="item.id" :label="item.title" :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-button type="primary" size="mini" @click.stop="statusBtn">确定</el-button>
                                    </div>
                                </div>
                                <div class="children">
                                    <div class="category-item">
                                        <div class="category-rules">
                                            <div class="select-item-list">
                                                <div class="hs-table-pro">
                                                    <div class="hs-table-row  hs-table-header">
                                                        <div class="hs-table-col">花类品种</div>
                                                        <div class="hs-table-col">供应商</div>
                                                        <div class="hs-table-col" v-for="(e,v) in rules" :key="v">
                                                            {{e.label}}
                                                        </div>
                                                        <div class="hs-table-col">数量</div>
                                                        <div class="hs-table-col">总价格</div>
                                                        <div class="hs-table-col">使用备注</div>
                                                        <div class="hs-table-col">结算</div>
                                                        <div class="hs-table-col">操作</div>
                                                    </div>
                                                    <div class="hs-table-row" v-for="(row,index) in addons" :key="index">
                                                        <div class="hs-table-col"> {{ getTagTitle(row.category_id) }}</div>
                                                        <div class="hs-table-col">
                                                            {{row.supplier ? row.supplier.title : '未分配'}}
                                                        </div>
                                                        <div class="hs-table-col"> {{ row.spec }}</div>
                                                        <template v-for="(e, f) in row">
                                                            <div class="hs-table-col" :key="f" v-if="f!='invalid' &&f!='invalid_id' && f!='settle_no' &&f!='count'&& f!='settle' &&f!='spec' &&f!='count' && f!='remark'&& f!='supplier'&& f!='price' && f!='product'&&f!='product_id' && f!='supplier_id' && f!='product_price'&& f!='category_id'&& f!='date'">
                                                                {{former.getRuleLabel(e,f,rules)}}
                                                            </div>
                                                        </template>
                                                        <div class="hs-table-col">{{row.count}}</div>
                                                        <div class="hs-table-col">
                                                            {{row.product ? row.product.price : '未分配'}}
                                                        </div>
                                                        <div class="hs-table-col">{{row.remark}}</div>
                                                        <div class="hs-table-col">
                                                            <template v-if="row.settle==1">结算中</template>
                                                            <template v-if="row.settle==2">结算通过</template>
                                                            <template v-if="row.settle==3">结算驳回</template>
                                                            <template v-if="!row.settle">待结算</template>
                                                        </div>
                                                        <div class="hs-table-col" v-if="row.settle!=2">
                                                            <el-link type="primary" class="mr8" @click="showDrawerPass(_self, 'supplierView', 'showDialog', [tItem.supplier, row])">编辑</el-link>
                                                        </div>
                                                        <div class="hs-table-col" v-else>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </el-form>

            </div>
        </div>
        <edit-view ref="editView" :parent="_self"></edit-view>
        <confirm-view ref="confirmView"></confirm-view>
        <supplier-view ref="supplierView" :parent="_self"></supplier-view>
    </div>
</el-drawer>
</template>

<script>
const ruleForm = {
    count: '',
    date: ''
};

import {
    showDrawerPass,
    getItemCheckTitle
} from '@/utils/common.js';
import former from '@/utils/former.js';
import weddingUtils from '@/utils/wedding.js';
import editView from './demand/edit.vue';
import confirmView from '@/components/audit/confirm.vue';
import supplierView from './demand/supplier.vue';
// 订单信息
import orderDetail from '@/components/order/detail'
export default {
    components: {
        editView,
        confirmView,
        supplierView,
        orderDetail
    },
    props: {
        parent: {}
    },
    data() {
        return {
            order_id: '',
            activeName: 'demand',
            ruleForm: Object.assign({}, ruleForm),
            category: [],
            categoryType: [],
            parent_id: 0,
            tree: [],
            selected: [],
            forms: {},
            module: 'wedding_demand',
            module_id: 0,
            activeNames: ['0'],
            drawerVisible: false,
            confirm: {},
            confirmStep: [],
            order: {},
            wedding: {},
            addons: {},
            category_parent_ids: ["11"],
            demand_ids: [],
            options: {},
            rules: [],
            status_id: 0,
            query: {
                weddingDay: []
            },
            type: "",
            statusList: [{
                id: 0,
                title: "待分配"
            }, {
                id: 1,
                title: '部分分配'
            }, {
                id: 2,
                title: '已完成'
            }],
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.former = former;
        this.getRuleTag = weddingUtils.getRuleTag;
        this.getItemCheckTitle = getItemCheckTitle;
    },
    methods: {
        getShowDate(options) {
            this.showDrawer(options)
        },
        showDrawer(options, query) {
            let _this = this;
            _this.drawerVisible = true;
            _this.options = options;
            _this.query = query; // 搜索条件
            let url = '/api/wedding.flower/collect';
            this.$post(url, {
                order_id: options.order_id,
                ...query
            }).then(function (res) {
                let resData = res.data;
                _this.addons = resData.addons;
                _this.query.weddingDay = res.data.date_range;
                _this.demand_ids = resData.demand_ids;
                _this.order_ids = options.order_id;
                _this.tree = resData.tree;
                _this.tree.map(item => {
                    item.children.map(i => {
                        _this.rules = i.rules;
                    })
                })
            });
        },
        editDrawer(row, type) {
            let _this = this;
            _this.drawerVisible = true;
            _this.options = row;
            _this.addons = row.addons;
            _this.demand_ids = row.demand_ids;
            _this.order_ids = row.order_ids;
            _this.type = type;
            _this.id = row.id;
            _this.status_id = row.status
            _this.query = {
                company_id: row.company_id
            }

            let url = '/api/wedding.flower/collect';
            this.$post(url, {
                order_id: row.order_ids,
            }).then(function (res) {
                let resData = res.data;
                _this.tree = resData.tree;
                _this.tree.map(item => {
                    item.children.map(i => {
                        _this.rules = i.rules;
                    })
                })
            });

        },
        statusBtn() {
            let _this = this;
            let url = '/api/wedding.flower/updateStatus';
            this.$post(url, {
                id: _this.id,
                status: _this.status_id
            }).then(function (res) {
                if (res.code == '200') {
                    _this.$message({
                        type: 'success',
                        message: res.msg
                    });
                    _this.parent.getTableData()
                } else {
                    _this.$message({
                        message: res.msg
                    });
                }
            });
        },
        //对应id到name
        getTagTitle(id) {
            let tree = this.tree;
            let title = '';
            tree.forEach((item) => {
                item.children.map(i => {
                    if (i.id == id) {
                        title = i.title;
                    }
                })

            });

            return title;
        },
        // 获取婚庆订单详情
        getOrderDetail(orderId) {
            let _this = this;
            let url = '/api/plan.order/detail';
            this.$post(url, {
                order_id: orderId
            }).then(function (res) {
                if (res.code == '200') {
                    _this.order = res.data.order;
                    _this.wedding = res.data.wedding;
                }
            });
        },
        submit() {
            //  return false
            let _this = this;

            if (_this.type == "edit") {
                let url = '/api/wedding.flower/save';
                let options = {
                    id: _this.id,
                    addons: Object.assign({}, _this.addons),
                }

                this.$post(url, options).then(function (res) {
                    if (res.code == '200') {
                        _this.parent.getTableData();
                        _this.$message({
                            type: 'success',
                            message: res.msg
                        });
                    } else {
                        _this.$message({
                            type: 'danger',
                            message: res.msg
                        });
                    }
                    _this.drawerVisible = false;
                });
            } else {
                let url = '/api/wedding.flower/create';
                let options = {
                    ..._this.query,
                    order_ids: _this.order_ids,
                    demand_ids: _this.demand_ids,
                    addons: Object.assign({}, _this.addons),
                }

                this.$post(url, options).then(function (res) {
                    if (res.code == '200') {
                        _this.$message({
                            type: 'success',
                            message: res.msg
                        });
                    } else {
                        _this.$message({
                            type: 'danger',
                            message: res.msg
                        });
                    }
                    _this.drawerVisible = false;
                });
            }

        },
        //暂存
        save() {
            let _this = this;
            let url = '/api/wedding.demand/save';
            let options = {};
            options.order_ids = _this.order_ids;
            options.demand_ids = _this.demand_ids;
            options.addons = Object.assign({}, _this.addons);
            this.$post(url, options).then(res => {
                if (res.code == '200') {
                    _this.drawerVisible = false
                    _this.$message({
                        type: 'success',
                        message: res.msg
                    });
                    _this.parent.showDrawer(options)
                } else {
                    _this.$message({
                        type: 'danger',
                        message: res.msg
                    })
                }
            });
        },
        projecFile() {
            let _this = this;
            let url = '/api/wedding.demand/download';
            let options = {};
            options.order_id = _this.order_id,
                options.type = "control_project",
                this.$post(url, options).then(res => {
                    if (res.code == '200') {
                        let link = document.createElement('a');
                        link.href = res.data.url;
                        link.click();

                    }
                })

        },
        closeDrawer() {
            this.drawerVisible = false;
        },
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.selected-list {
    padding-left: 12px;
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
        display: flex;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}

/*** --------------------------------------- 分界线 ------------------------ ***/
.form-header {
    display: flex;
    padding: 12px;
    border-bottom: 1px solid #dedede;

    .form-submit {
        flex: 1;
        text-align: right;
    }
}

.main-demand {
    display: flex;
    overflow: auto;

    .form-demand {
        flex: 1;
        padding-bottom: 20px;
    }

    .more-demand {
        flex: 0 25%;
        padding: 12px;
        border-left: 1px solid #dedede;
    }
}

.hs-table-pro {
    .hs-table-row {
        display: flex;
        border-top: .5px solid #f6f7fb;

        .hs-table-col {
            flex: 1;
            padding: 5px 8px;
            border-right: .5px solid #f6f7fb;
        }

        .hs-table-col.w80 {
            flex: 0 80px;
        }
    }

    .hs-table-row.hs-table-header {
        background: #f6f7fb;
        border-top: none;
    }
}
</style>
